import { useMutation } from '@vue/apollo-composable'
import gql from 'graphql-tag'

const MUTATION = gql`
  mutation SetStepPreferred3dModel($command: SetStepPreferred3dModel!) {
    product {
      setStepPreferred3dModel(command: $command) {
        id
      }
    }
  }
`

export function useSetStepPreferred3dModel() {
  const { mutate } = useMutation<
    unknown,
    { command: { stepId: string; bopUploadId: string | null } }
  >(MUTATION, { refetchQueries: ['BopStepViewerData'] })

  return async (stepId: string, bopUploadId: string | null) => {
    await mutate({ command: { stepId, bopUploadId } })
  }
}
